module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/beauty-mobile@2x-7b64552badedb4f584cf5c0820793257.jpg";